// extracted by mini-css-extract-plugin
export default {"circle":"styles_circle__dKA2Y","read":"styles_read__KvV-1","background":"styles_background__0QbNv","animate":"styles_animate__uOMnq","bounce":"styles_bounce__q0fHI"};